<template>
    <div>
        <el-form :model="searchForm" :inline="true" class="forTbFilter">
           
            <el-form-item label="下单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getListPageHandle">搜索</el-button>
            </el-form-item>
        </el-form>
    <el-row>
      <el-button type="primary" plain @click="lunXunSimTimer" >SIM卡轮训</el-button>
      <el-button type="primary" plain @click="lunXunAgentTimer" >代理商统计</el-button>
      <el-button type="primary" plain @click="lunXunPauseTimer" >没有次月套餐停机</el-button>
       <el-button type="primary" plain @click="lunXunActiveTimer" >月初复机</el-button>
     </el-row>
        <el-table :data="tbpg.tableData"  style="width:100%;margin-top: 20px;"
		 border
		 fit
		 highlight-current-row
		 :header-cell-style="{background:'#f5f5f5'}"
		   :default-sort = "{prop: 'rpTime', order: 'descending'}"
		 > 
            <el-table-column prop="id" label="SIM轮训序号" align="center"></el-table-column>
             <el-table-column prop="remark" label="轮训名称"  align="center"></el-table-column>
            <el-table-column prop="total" label="SIM轮训总数"  align="center"></el-table-column>
            <el-table-column prop="successSim" label="SIM成功总数" align="center" ></el-table-column>
            <el-table-column label="SIM失败总数" align="center">
                <template slot-scope="scope">
                    <a href="javascript:void(0);" @click="goToInfoFailPage(scope.row.id, $event)"  style="color:red;font-size:18">{{scope.row.failSim}}</a>
                </template> 
            </el-table-column>
            <el-table-column prop="failSim" label="SIM失败总数"  align="center"></el-table-column>
            <el-table-column prop="remainSim" label="SIM剩余总数"  align="center"></el-table-column>
            <el-table-column prop="createTime" label="轮训时间"  align="center"></el-table-column>
            
        </el-table>       
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
        <el-dialog :append-to-body="true"  title="失败记录" :visible.sync="failVisible" width="1000px" :close-on-click-modal="false" @close="cancel">
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号"></el-table-column>
                <el-table-column prop="remarks" label="失败原因"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>
    </div>
</template>
<script>
import common from '@/utils/common.js'
import {getBgdRechargeList, getBgdRechargeFailLists, getPkgListOfGroup} from '@/api/sim.js'
export default {
    data(){
        return {
            searchForm: {
                downOrder: '',
                upOrder: '',
                iccid: '',
                isNextMonth: '',
                payState:'',
                time: ''
            },

            //订单列表
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            failVisible: false,  
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    methods: {
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('lunxun/sim/list', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        handleSizeChange(val){
             if(this.failVisible){
             this.tbpg_fail.currentPage = val
            this.goToInfoFailPage(this.currentId_fail);  
           }else{
                this.tbpg.currentPage = val
            this.getListPageHandle();  
           }   
        },
        //失败列表
        goToInfoFailPage(id, $event){
          this.failVisible = true;
            this.currentId_fail = id;
            var data = {
                'id': id
            }
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', data);

            getBgdRechargeFailLists(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
        handleCurrentChange(val){
            if(this.failVisible){
             this.tbpg_fail.currentPage = val
            this.goToInfoFailPage(this.currentId_fail);  
           }else{
                this.tbpg.currentPage = val
            this.getListPageHandle();  
           }                  
        },
        //执行sim卡轮训
        lunXunSimTimer(){
            const h = this.$createElement;
        this.$msgbox({
          title: '执行轮训',
          message: h('p', null, [
            h('span', null, '如果有轮训尚未结束，请勿重复执行轮训！确定要手动执行SIM卡轮训吗？')
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {      
            let iccid=1;
            common.sysRequest('lunxun/sim',iccid,'get').then(res=> {
                if(res.data.code == 200){
                    this.getListPageHandle();
                    this.$message.success(res.data.message);
                    done();
                }else{
                    this.$message.error(res.data.message);
                    done();
                }
            }
            )
            } else {
              done();
            }
          }
        })
        

        },
          //执行代理商统计
     lunXunAgentTimer(){
      const h = this.$createElement;
        this.$msgbox({
          title: '执行轮训',
          message: h('p', null, [
            h('span', null, '确认要手动执行代理商统计吗？')
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {      
            let iccid=1;
            common.sysRequest('lunxun/agentCount',iccid,'get').then(res=> {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                     this.getListPageHandle();
                     done();
                }else{
                    this.$message.error(res.data.message);
                }
            }
            )
            } else {
              done();
            }
          }
        })
                   
        },
     lunXunPauseTimer(){
      const h = this.$createElement;
        this.$msgbox({
          title: '执行轮训',
          message: h('p', null, [
            h('span', null, '确认要手动执行没有次月套餐停机吗？此操作请谨慎操作！')
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {      
            let iccid=1;
            common.sysRequest('lunxun/pause/sim',iccid,'get').then(res=> {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                     this.getListPageHandle();
                     done();
                }else{
                    this.$message.error(res.data.message);
                }
            }
            )
            } else {
              done();
            }
          }
        })
                   
    },
    lunXunActiveTimer(){
      const h = this.$createElement;
        this.$msgbox({
          title: '执行轮训',
          message: h('p', null, [
            h('span', null, '确认要手动执行有有效套餐复机吗？')
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {      
            let iccid=1;
            common.sysRequest('lunxun/active/sim',iccid,'get').then(res=> {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                     this.getListPageHandle();
                     done();
                }else{
                    this.$message.error(res.data.message);
                }
            }
            )
            } else {
              done();
            }
          }
        })
                   
    },
        //重新购买
        buyPkgReload(rowData){
            let data = {
                id: rowData.id,
                iccid: rowData.iccid,
                otherOrderNo:rowData.downOrder,
                isNextMonth :rowData.isNextMonth,
                packgeId:rowData.downPackageId
            }
            common.sysRequest('external/buy/pkg/reload', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.getListPageHandle();
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message);
                }
                
            })
        }

    
    },
    created () {
        this.getListPageHandle();
    },
}
</script>
<style lang="less">
.notifyDetail {
    h3 {
        text-align: center;
        margin-bottom: 10px;
    }
    p {
        text-indent: 2em;
        line-height: 1.5em;
    }
}
</style>

